import { render, staticRenderFns } from "./ProjectGroupFormModal.vue?vue&type=template&id=d8155c72&"
import script from "./ProjectGroupFormModal.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports